<template>
  <div>
    <v-container v-if="section_info.course_id" fluid>
      <v-card flat tile>
        <v-row>
          <v-col class="d-flex justify-space-around mb-6" flat tile>
            <v-card-actions>
              <v-select
                v-model="unit"
                :items="section.units"
                label="Select Unit"
              />
            </v-card-actions>
          </v-col>
        </v-row>
        <v-simple-table
          class="align-start overflow-x: scroll"
          fixed-header
          height="100%"
          dense
        >
          <thead>
            <tr>
              <th>
                <v-list-item class="px-2">
                  <v-list-item-icon>
                    <v-icon color="secondary"> mdi-account-multiple </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Class Average</v-list-item-title>
                </v-list-item>
              </th>
              <th></th>
              <th
                class="text-center"
                v-for="assessment in sortedAssessments"
                :key="assessment.id"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <span v-if="assessment.name.length > 32">
                        {{ assessment.name.substr(0, 15) }} ...
                        {{ assessment.name.substr(-15) }}
                      </span>
                      <span v-else>
                        {{ assessment.name }}
                      </span>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small v-bind="attrs" v-on="on">
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list dense>
                          <v-list-item dense>
                            <v-list-item-icon class="mx-1">
                              <v-icon
                                dense
                                small
                                @click="deleteAssessment(assessment)"
                              >
                                mdi-trash-can
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-subtitle> Remove</v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                  <span class="text-align: center">
                    {{ assessment.name }}
                  </span>
                </v-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in section.students" :key="student.id">
              <th>
                <v-list-item class="px-2">
                  <v-list-item-avatar>
                    <v-img :src="student.portrait_img"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-title>
                    {{ student.full_name_2 }}
                  </v-list-item-title>
                </v-list-item>
              </th>
              <th>
                <v-card
                  outlined
                  class="ma-0 px-0"
                  elevation="3"
                  dense
                  height="100%"
                  min-width="75"
                >
                  <v-card-text>
                    {{ getAvg(student) }}
                    <v-btn
                      small
                      icon
                      v-if="
                        transferred.filter((t) => t.user_id == student.id)
                          .length > 0
                      "
                      @click="viewTransfers(student)"
                    >
                      <v-icon small> mdi-transfer </v-icon>
                    </v-btn>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th>
                              <v-btn icon @click="getComments(student)">
                                <v-icon small> mdi-chat </v-icon>
                              </v-btn>
                            </th>
                            <th v-for="gp in grading_periods" :key="gp.id">
                              {{ gp.name }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            <td v-for="gp in grading_periods" :key="gp.id"></td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-menu>
                  </v-card-text>
                </v-card>
              </th>
              <td
                v-for="assessment in sortedAssessments"
                :key="assessment.id"
                class="pa-0"
                align="center"
              >
                <v-card
                  outlined
                  max-width="120"
                  width="120"
                  height="100%"
                  v-if="activeGrading == assessment.id + '-' + student.id"
                >
                  <v-card-text class="pa-0">
                    <v-select
                      v-model="newScore"
                      :items="options"
                      dense
                      @change="processGrading(assessment, student)"
                    ></v-select>
                  </v-card-text>
                </v-card>
                <v-card
                  outlined
                  max-width="120"
                  width="120"
                  height="100%"
                  v-else
                  @click="activeGrading = assessment.id + '-' + student.id"
                >
                  {{ getScore(student, assessment) }}
                </v-card>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <v-dialog v-model="commentsDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Comments</span>
          <v-spacer />
          <v-btn icon @click="commentsDialog = false">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-card flat tile v-for="comment in comments" :key="comment.id">
              {{ new Date(comment.created_at).toLocaleDateString() }}
              {{ comment.text }}
              <v-btn icon
                ><v-icon small color="red" @click="deleteComment(comment.id)"
                  >mdi-close</v-icon
                ></v-btn
              >
            </v-card>
            <v-textarea
              v-model="newComment"
              label="New Comment"
            >
            </v-textarea>
            <v-select
              v-model="selectedComment"
              :items="commentsList"
              label="Add to the comment"
            >
            </v-select>
            <v-card-actions>
              <v-btn color="primary" @click="saveComment">Save</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    section_info: {
      type: Object,
      required: true,
    },
    grading_period: {
      type: Object,
      required: true,
    },
    grading_periods: {
      type: Array,
      required: true,
    },
  },
  watch: {
    section_info: "getSectionAssessments",
    selectedComment: "appendComment",
    unit: "saveAssessments",
    grading_period: function() {
      this.unit = ""
    }
  },
  data: () => ({
    options: [
      { value: 4, text: "Above Grade Level" },
      { value: 3, text: "At Grade Level" },
      { value: 2, text: "Below Grade Level" },
      { value: 1, text: "Significantly Below Grade Level" },
      { value: "", text: "N/A" },
    ],
    snackbar: false,
    snackbarMessage: "",
    activeGrading: "",
    newScore: null,
    note: "",
    excluded: false,
    transfersDialog: false,
    studentsTransfers: [],
    noteDialog: false,
    gradeForNote: {},
    inputRules: [(v) => !!v || "Required"],
    dialogLabel: null,
    dialog: false,
    menu: false,
    editedAssessmentId: null,
    assessment: {
      name: null,
      date: new Date().toLocaleDateString(),
      type: null,
      possible: 100,
      weight: 1,
      description: null,
    },
    section: {
      assessments: [],
      students: [],
      units: [],
      standards: [],
    },
    grades: [],
    transferred: [],
    commentsDialog: false,
    newComment: "",
    selectedComment: "",
    commentsList: [
      "A pleasure to have in class",
      "Works hard",
      "Improved effort",
      "Homework not handed in",
      "Frequently tardy",
      "Frequently absent",
      "Grade reflects poor test scores",
      "Talkative and/or disruptive",
      "Parent teacher conference requested",
      "In danger of failing",
      "Unsatisfactory or no project work",
      "Unsatisfactory participation",
      "Actual grade is below 50",
    ],
    studentToComment: 0,
    comments: [],
    sections: [],
    unit: "",
  }),
  computed: {
    sortedAssessments() {
      return this.section.assessments
        .filter(
          (a) =>
            a.type == this.unit &&
            new Date(a.date) <= new Date(this.grading_period.end_date) &&
            new Date(a.date) >= new Date(this.grading_period.start_date)
        )
        .sort((a, b) => {
          return b.name - a.name;
        });
    },
  },
  methods: {
    appendComment() {
      if (this.selectedComment !== 0)
        this.newComment += this.selectedComment +  " "
      this.selectedComment = 0
    },
    getAvg(student) {
      let ids = this.sortedAssessments.map(assessment => assessment.id) || []
      let grades = this.grades.filter(
        (grade) =>
          grade.user_id == student.id && 
          ids.includes(grade.assessment_id) &&
          grade.score !== ""
      ).map(grade => grade.score)
      let sum = grades.reduce((prev, score) => { return prev + score; }, 0);
      return Math.round(10 * sum / grades.length) / 10 || 'N/A';
    },
    getComments(student) {
      this.$sisApi("get", `my-schedule/student-comments`, {
        user_id: student.id,
        section_id: this.section_info.section_id,
      })
        .then((response) => {
          this.commentsDialog = true;
          this.comments = response.data;
          this.studentToComment = student.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteAssessment(assessment) {
      let num = this.grades.filter(
        (grade) => grade.assessment_id == assessment.id && grade.score != ""
      ).length;
      if (num == 0) {
        this.$sisApi("delete", `my-schedule/assessment/${assessment.id}`).then(
          () => {
            let index = this.section.assessments.findIndex(
              (a) => a.id == assessment.id
            );
            this.section.assessments.splice(index, 1);
          }
        );
      } else {
        this.snackbar = true;
        this.snackbarMessage = "Gradebook entries with grades can't be deleted";
      }
    },
    saveComment() {
      this.$sisApi("post", `my-schedule/student-comment`, {
        user_id: this.studentToComment,
        section_id: this.section_info.section_id,
        text: this.newComment,
      })
        .then((response) => {
          this.newComment = ""
          this.selectedComment = 0
          this.comments.push(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteComment(cid) {
      this.$sisApi("delete", `my-schedule/student-comment/${cid}`)
        .then(() => {
          let index = this.comments.findIndex((c) => c.id == cid);
          this.comments.splice(index, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    viewTransfers(student) {
      this.transfersDialog = true;
      this.studentsTransfers = this.transferred.filter(
        (t) => t.user_id == student.id
      );
    },
    getScore(student, assessment) {
      let ind = this.grades.findIndex(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      let sc = "";
      if (ind > -1) {
        sc = this.grades[ind].score;
        ind = this.options.findIndex((o) => o.value == sc);
      }
      return ind > -1 ? this.options[ind].text : sc;
    },
    saveNotes() {
      this.gradeForNote.note = this.note;
      this.gradeForNote.excluded = this.excluded;
      this.$sisApi("post", `my-schedule/grade`, this.gradeForNote)
        .then((response) => {
          this.section.students.find(
            (s) => s.id == this.gradeForNote.user_id
          ).avg = response.data;
          this.gradeForNote = {};
          this.noteDialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addNote(student, assessment) {
      this.note = "";
      this.excluded = 0;
      this.gradeForNote = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      this.noteDialog = true;
    },
    getSectionAssessments() {
      this.$sisApi("get", `my-schedule/gradebook`, {
        course_id: this.section_info.course_id,
        section: this.section_info.section_name,
      })
        .then((response) => {
          this.section.assessments = response.data.assessments;
          this.section.students = response.data.students;
          this.grades = response.data.scores;
          this.transferred = response.data.transferred;
          this.sections = response.data.sections;
          // remove current section from options
          let index = this.sections.findIndex(
            (s) => s.id == this.section_info.section_id
          );
          this.sections.splice(index, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    processGrading(assessment, student) {
      let grade = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      if (this.newScore !== grade.score) {
        this.postGrade(assessment, student);
        this.activeGrading = "";
        this.newScore = null;
      }
    },
    assessmentAvg(id) {
      let a = this.grades
        .filter(
          (g) => g.assessment_id == id && g.score !== "" && g.score != null
        )
        .map((g) => g.score);
      if (a.length == 0) return "";
      return Math.round(
        a.reduce((sum, val) => sum + parseFloat(val), 0) / a.length
      );
    },
    saveAssessments() {
      if (this.unit == "") {
        return;
      }
      let editedAssess = { ...this.assessment };
      editedAssess.type = this.unit;
      editedAssess.possible = this.options.length;
      editedAssess.date = this.grading_period.end_date.substr(0, 10);
      this.section.standards
        .filter((s) => s.unit == this.unit && !this.sortedAssessments.map(a => a.name).includes(s.objective))
        .forEach((s) => {
          editedAssess.name = s.objective;
          this.$sisApi(
            "post",
            `my-schedule/assessment/${this.section_info.section_id}`,
            editedAssess
          )
            .then((response) => {
              this.section.assessments.push(response.data);
              this.section.students.forEach((student) => {
                this.grades.push({
                  section_id: this.section_info.section_id,
                  assessment_id: response.data.id,
                  user_id: student.id,
                  excluded: 0,
                  score: "",
                  note: "",
                });
              });
            })
            .catch((error) => {
              console.log(error);
            });
        });
    },
    postGrade(assessment, student) {
      let grade = this.grades.find(
        (g) => g.user_id == student.id && g.assessment_id == assessment.id
      );
      if (parseFloat(this.newScore) > parseFloat(assessment.possible)) {
        this.newScore = assessment.possible;
      }
      let prev = grade.score;
      grade.score = this.newScore;
      this.$sisApi("post", `my-schedule/grade`, grade)
        .then((response) => {
          let index = this.section.students.findIndex(
            (s) => s.id == grade.user_id
          );
          this.section.students[index].avg = response.data;
        })
        .catch((error) => {
          console.log(error);
          grade.score = prev;
          this.snackbar = true;
          this.snackbarMessage = "The score is not updated";
        });
    },
  },
  mounted() {
    if (this.section_info.course_id) {
      this.section.standards = this.section_info.standards;
      this.section.units = this.section_info.standards
        // collect units
        .map((s) => s.unit)
        // filter out duplicates
        .filter((value, index, self) => self.indexOf(value) === index);
      this.getSectionAssessments();
    }
    this.allowed = true;
  },
};
</script>
